import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot
} from "@angular/router";
import { Injectable } from "@angular/core";

import { AppState } from "@store/state";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { map, take } from "rxjs/operators";
import { StorageService } from "../storage/storage";
import { User } from "@tendercuts/models";

/**
 * If the user is logged in already, we push him to dashboard
 * when ever we reload the app AuthGuardService will hit
 */
@Injectable()
export class AuthGuardService implements CanActivate {
  constructor(private route: Router, private store: Store<AppState>) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const sourceUrl = state.url;
    return this.store
      .select(appState => appState)
      .pipe(
        take(1),
        map((appState: AppState) => {
          let userExists =
            appState.userState != undefined &&
            appState.userState.user != undefined;
          if (userExists == false) {
            this.route.navigate(["/login"], {
              queryParams: { redirect: sourceUrl }
            });
          }

          return userExists;
        })
      );
  }
}

/**
 * Once the order placed we are clearing the cart
 * after we move to home page for next order team using 
 * chrome back button it is redirecting to payment page without quote user
 * so that payment route handling we used PaymentAuthGuardService.  
 */
export class PaymentAuthGuardService implements CanActivate {
  constructor(private route: Router, private store: Store<AppState>) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const sourceUrl = state.url;
    return this.store
      .select(appState => appState)
      .pipe(
        take(1),
        map((appState: AppState) => {
          let userExists =  true;
          if (!appState.cartState.quote.user || !appState.cartState.quote.cartProducts.length) {
            this.route.navigate(["/home"]);
            userExists = false;
          }

          return userExists;
        })
      );
  }
}

/**
 * once app is load team using chrome back button it redirect to 
 * login page if user exists also
 * so that we using seperate LoginAuthGuardService for login param 
 */
export class LoginAuthGuardService implements CanActivate {
  constructor(private route: Router, private storage: StorageService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.storage.getData("pos_user", User).pipe(
      map((user: User) => {
        let userExists = true;
        if (user && user.isValid) {
          this.route.navigate(["/home"]);
          userExists = false;
        }

        return userExists;
      })
    );
  }
}
